import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { uuid } from '@atlaskit/adf-schema';
import { mapSlice } from '../utils/slice';
export var transformToNewReferenceSyncBlock = function transformToNewReferenceSyncBlock(slice, schema) {
  slice = mapSlice(slice, function (node) {
    // sync blocks need a unique localId to function correctly
    if (node.type === schema.nodes.syncBlock) {
      var newAttrs = _objectSpread(_objectSpread({}, node.attrs), {}, {
        localId: uuid.generate()
      });
      return schema.nodes.syncBlock.create(newAttrs, null, _toConsumableArray(node.marks));
    } else if (node.type === schema.nodes.bodiedSyncBlock) {
      // bodied sync blocks need a unique localId and convert to a reference sync block
      // when converting we want to be specific about attributes and marks we carry over
      var _newAttrs = {
        resourceId: node.attrs.resourceId,
        localId: uuid.generate()
      };
      var newMarks = schema.nodes.syncBlock.markSet ? node.marks.filter(function (mark) {
        var _schema$nodes$syncBlo;
        return (_schema$nodes$syncBlo = schema.nodes.syncBlock.markSet) === null || _schema$nodes$syncBlo === void 0 ? void 0 : _schema$nodes$syncBlo.includes(mark.type);
      }) : node.marks; // schema.nodes.syncBlock.markSet is null meaning all marks are allowed

      return schema.nodes.syncBlock.create(_newAttrs, null, newMarks);
    }
    return node;
  });
  return slice;
};